import React from "react";
import AppIcon from "@vcomponents/AppIcon";
import { emptyListIcon } from "@src/assets/images/svgs";

import "./style.scss";

import { CustomFormattedMessage } from "@src/utility/context/CustomFormattedMessage";

/**
 * EMPTY LIST MESSAGE
 * @returns JSX.Element
 */
const NoData = () => {
  const text = "This list is empty at the moment";
  return (
    <div className="noData">
      <AppIcon icon={emptyListIcon} />.
      <p className="noData--text">
        <CustomFormattedMessage id={text} defaultMessage={text} />
      </p>
    </div>
  );
};

export default NoData;
